export type {
  TDailyMarkingContext,
  TDaySchedule,
  TExpectedMark,
  TShiftContext,
} from './use-get-daily-marking';
export { useGetDailyMarking } from './use-get-daily-marking';
